export default "__VITE_ASSET__07e7851d__"